import { connect } from "react-redux";
import Resources from "./Resources";
import {
  getError,
  users,
  userStatusLoading,
  usersPagination,
  usersLoading,
} from "../../store/selectors/user.selector";
import {
  getUsers,
  createUserRequest,
  updateUserRequest,
  deleteUserRequest,
  getPermissionsRequest,
} from "../../store/actions/user.actions";

const mapDispatchToProps = {
  getUsersRequest: getUsers,
  getPermissionsRequest,
  createUserRequest,
  updateUserRequest,
  deleteUserRequest,
};

const mapStateToProps = (state) => {
  const allUsers = users(state);
  const pageLoading = usersLoading(state);
  const loading = userStatusLoading(state);
  const pagination = usersPagination(state);
  const error = getError(state);
  return { error, pagination, allUsers, loading, pageLoading };
};

export default connect(mapStateToProps, mapDispatchToProps)(Resources);
